import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'worker-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent implements OnInit {

  uploader:FileUploader;
  hasBaseDropZoneOver:boolean;
  hasAnotherDropZoneOver:boolean;
  response:string;

  upload_errors = false;

  file_error = "";
  

  @Input() worker:any;

  @Output() imageUploaded = new EventEmitter();
 
  constructor (public okService:OkAloneService){
 
    this.hasBaseDropZoneOver = false;
    this.hasAnotherDropZoneOver = false;

    let url = this.okService.getUrl('workers/profileupload/');
    this.uploader = new FileUploader({url: url});
 
    this.response = '';

  }

  ngOnInit(): void {

    //console.log(this.worker);
    this.setupLoader();

  }

  setupLoader(){

    let url = this.okService.getUrl('workers/profileupload/'+this.worker.id);
    //console.log(url);

    let token = "Bearer "+this.okService.session.token;
    //console.log(token);

    let headers: { name: string; value: string }[] = [];
    if (this.okService.session.cid) {
      headers.push({ name: 'cid', value: this.okService.session.cid });
    }

    this.uploader = new FileUploader({
      url: url,
      authToken: token,
      headers: headers,
      itemAlias:"upload",
      disableMultipart: false, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
      // formatDataFunctionIsAsync: true,
      // formatDataFunction: async (item:any) => {
      //   return new Promise( (resolve, reject) => {
      //     resolve({
      //       name: item._file.name,
      //       length: item._file.size,
      //       contentType: item._file.type,
      //       date: new Date()
      //     });
      //   });
      //}
    });

    this.uploader.onAfterAddingFile = (item => {
       item.withCredentials = false;
    });
 
    this.uploader.response.subscribe( res => {

      this.file_error = "";


      let response = JSON.parse(res);

      if(response.error){

        this.file_error = response.error;

      }else{
        this.imageUploaded.emit();
      
        this.reset();
      }


    } );


  }
 
  public fileOverBase(e:any):void {
    this.hasBaseDropZoneOver = e;
  }
 
  public fileOverAnother(e:any):void {
    this.hasAnotherDropZoneOver = e;
  }

  reset(){
    this.upload_errors = false;
    this.setupLoader();
  }
}
